export default [
  {
    name: 'plans.register.index',
    path: '/plans/register',
  },
  {
    name: 'plans.pricing.index',
    path: '/plans/pricing',
  },
];
